import {Component, DestroyRef, inject, Injector, OnInit} from "@angular/core";
import {
    ShareableProduct,
    ShareProductsViewModel
} from "@app/presentation/pages/share-products/share-products.view-model";
import {AppBarModule} from "@app/presentation/components/app-bar/app-bar.module";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {AsyncPipe} from "@angular/common";
import {CheckboxModule} from "@app/presentation/components/checkbox/checkbox.module";
import {ProductListModule} from "@app/presentation/components/product-list/product-list.module";
import {ButtonModule} from "@app/presentation/components/button/button.module";
import {Product} from "@app/core/product/domain/dtos/product";
import {ShareService} from "@app/presentation/services/share/share.service";
import {PopupDispatcher} from "@app/presentation/components/errors/popup.dispatcher";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {ModalService} from '@app/presentation/services/modal/modal.service';

@Component({
    standalone: true,
    templateUrl: './share-products.component.html',
    styleUrls: ['./share-products.component.scss'],
    imports: [
        AppBarModule,
        TranslateModule,
        AsyncPipe,
        CheckboxModule,
        ProductListModule,
        ButtonModule
    ],
    providers: [ShareProductsViewModel]
})
export class ShareProductsComponent implements OnInit {

    private readonly vm = inject(ShareProductsViewModel);
    private readonly injector = inject(Injector);
    private readonly shareService = inject(ShareService);
    private readonly translateService = inject(TranslateService);
    private readonly popupDispatcher = inject(PopupDispatcher);
    private destroyRef = inject(DestroyRef);

    products: Product[] = [];

    shareableProducts$ = this.vm.shareableProducts$;
    canShareProducts$ = this.vm.canShareProducts$;
    isProductsSharingLoading$ = this.vm.isProductsSharingLoading$;
    allProductsSelected$ = this.vm.allProductsSelected$;
    areSelectedProductsGreaterThanMax$ = this.vm.areSelectedProductsGreaterThanMax$;
    exceededSelectedProductsCount$ = this.vm.exceededSelectedProductsCount$;

    ngOnInit(): void {

        this.popupDispatcher.setNotifier(this.vm.notifier);

        const modalData = ModalService.getModalData(this.injector);
        if (modalData != null) {
            this.products = modalData.products;
        }

        this.vm.actionLoadProducts(this.products);

        this.vm.sharedProductsUrlCreatedEvent$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: url => {
                    const title = this.translateService.instant('share_products.share_link_title');
                    const message = this.translateService.instant('share_products.share_link_text');
                    this.shareService.share({
                        dialogTitle: title,
                        text: message,
                        url: url,
                    })
                }
        });
    }

    handleOnSelectProductChange(event: Event, product: ShareableProduct): void {
        const target = event.target as HTMLInputElement;
        if (target == null) {
            return;
        }
        this.vm.actionSelectProduct(product.product, target.checked);
    }

    handleOnSelectAllChange(event: Event) {
        this.vm.actionSelectAllProducts((event.target as HTMLInputElement).checked);
    }

    shareSelectedProducts() {
        this.vm.actionShareSelectedProducts();
    }

}